const enum KeyCode {
  Tab = 9,
  Space = 32,
  Left = 37,
  Up = 38,
  Right = 39,
  Down = 40,
}

export default KeyCode
